export class StorageConstants {
  static readonly user: string = 'user';
  static readonly userId: string = 'userId';
  static readonly token: string = 'token';
  static readonly deviceVerified: string = 'deviceVerified';
  static readonly userAccount: string = 'userAccount';
  static readonly rememberAccount: string = 'rememberAccount';
  static readonly cards: string = 'userCards';
  static readonly lastFailedLoginAttemptDate: string = 'lastFailedLoginAttemptDate';
  static readonly failedLoginAttempts: string = 'failedLoginAttempts';
  static readonly recoveryDevice: string = 'recoveryDevice';
}
